/* arvs.js — behaviour for arvs-* sections. Included by several sections; runs once. Every feature degrades:
   no JS = all content visible, the native form still submits, details/summary still open. */
(function () {
  if (window.__arvs) return;
  window.__arvs = true;
  window.__arvsReady = true;
  var doc = document.documentElement;
  doc.classList.add('arvs-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function each(sel, fn, root) { Array.prototype.forEach.call((root || document).querySelectorAll(sel), fn); }
  function once(el, key) { if (el.dataset[key]) return false; el.dataset[key] = '1'; return true; }

  function reveal() {
    var els = [];
    each('.arvs-rv', function (el) { if (once(el, 'arvsRv')) els.push(el); });
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (el) { el.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
    els.forEach(function (el) { io.observe(el); });
  }

  function rings() {
    each('.arvs-ring', function (ring) {
      if (!once(ring, 'arvsRing')) return;
      var val = ring.querySelector('[data-arvs-count]');
      var finalText = val ? val.textContent : '';
      var target = val ? parseFloat(val.getAttribute('data-arvs-count')) || 0 : 0;
      var suffix = val ? val.getAttribute('data-arvs-suffix') || '' : '';
      function run() {
        ring.classList.add('is-in');
        if (!val || reduce || !target) return;
        var t0 = performance.now(), dur = 1600;
        (function step(t) {
          var p = Math.min(1, (t - t0) / dur), e = 1 - Math.pow(1 - p, 3);
          val.textContent = p < 1 ? Math.round(target * e) + suffix : finalText;
          if (p < 1) requestAnimationFrame(step);
        })(t0);
      }
      if (reduce || !('IntersectionObserver' in window)) { ring.classList.add('is-in'); return; }
      var io = new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) { io.disconnect(); run(); }
      }, { threshold: 0.35 });
      io.observe(ring);
    });
  }

  function galleries() {
    each('[data-arvs-gal]', function (g) {
      if (!once(g, 'arvsGal')) return;
      var track = g.querySelector('.arvs-gal__track');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      var thumbs = Array.prototype.slice.call(g.querySelectorAll('.arvs-gal__thumb'));
      var prev = g.querySelector('.arvs-gal__arrow--prev'), next = g.querySelector('.arvs-gal__arrow--next');
      var idx = 0;
      function mark(i) {
        idx = i;
        thumbs.forEach(function (t, k) { t.setAttribute('aria-current', k === i ? 'true' : 'false'); });
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
        var th = thumbs[i];
        if (th && th.parentNode) th.parentNode.scrollTo({ left: th.offsetLeft - 8, behavior: reduce ? 'auto' : 'smooth' });
      }
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({ left: i * track.clientWidth, behavior: reduce ? 'auto' : 'smooth' });
        mark(i);
      }
      var tick;
      track.addEventListener('scroll', function () {
        clearTimeout(tick);
        tick = setTimeout(function () { var i = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)); if (i !== idx) mark(i); }, 60);
      }, { passive: true });
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      if (prev) prev.addEventListener('click', function () { go(idx - 1); });
      if (next) next.addEventListener('click', function () { go(idx + 1); });
      track.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); }
      });
      g.addEventListener('arvs:media', function (e) {
        for (var k = 0; k < slides.length; k++) { if (slides[k].getAttribute('data-media-id') === String(e.detail)) { go(k); break; } }
      });
      mark(0);
    });
  }

  function buyboxes() {
    each('[data-arvs-buybox]', function (bb) {
      if (!once(bb, 'arvsBb')) return;
      var radios = Array.prototype.slice.call(bb.querySelectorAll('.arvs-tier__input'));
      if (!radios.length) return;
      function outs() { return document.querySelectorAll('[data-arvs-price-out]'); }
      function sync(userChange) {
        var r = radios.filter(function (x) { return x.checked; })[0];
        if (!r) return;
        Array.prototype.forEach.call(outs(), function (o) { o.textContent = r.getAttribute('data-price'); });
        var atc = document.querySelectorAll('[data-arvs-atc]');
        Array.prototype.forEach.call(atc, function (b) { b.disabled = r.disabled; });
        if (!userChange) return;
        var mid = r.getAttribute('data-media-id');
        var gal = bb.querySelector('[data-arvs-gal]');
        if (mid && gal) gal.dispatchEvent(new CustomEvent('arvs:media', { detail: mid }));
        // the radios carry a QUANTITY of one variant (bundles = N units), never a variant id: no ?variant= sync from them
      }
      radios.forEach(function (r) { r.addEventListener('change', function () { sync(true); }); });
      sync(false);
    });
  }

  function sticky() {
    each('[data-arvs-sticky]', function (bar) {
      if (!once(bar, 'arvsSticky')) return;
      var atc = document.querySelector('[data-arvs-atc]');
      if (!atc) return;
      // on only once the visitor is PAST the main button (never over the first screen), off while the footer shows.
      // Measured on scroll, not IntersectionObserver: a jump link (stars -> reviews) skips over the button in one
      // frame and an observer never fires for a target that goes from below the viewport to above it.
      var foot = document.querySelector('footer, .footer, [id*="footer-group"]');
      var queued = false;
      function update() {
        queued = false;
        if (!bar.isConnected) return;
        var passed = atc.getBoundingClientRect().bottom < 0;
        var footSeen = foot ? foot.getBoundingClientRect().top < window.innerHeight : false;
        var on = passed && !footSeen;
        if (bar.classList.contains('is-on') !== on) { bar.classList.toggle('is-on', on); bar.inert = !on; }
      }
      function queue() { if (!queued) { queued = true; window.requestAnimationFrame(update); } }
      bar.inert = true;
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue, { passive: true });
      update();
    });
  }

  function tabs() {
    each('[data-arvs-tabs]', function (box) {
      if (!once(box, 'arvsTabs')) return;
      var list = Array.prototype.slice.call(box.querySelectorAll('[role="tab"]'));
      // the server leaves every panel visible (no-JS readers get them all); hide the unselected ones here
      list.forEach(function (x) {
        var p = document.getElementById(x.getAttribute('aria-controls'));
        if (p) { p.hidden = x.getAttribute('aria-selected') !== 'true'; p.removeAttribute('data-arvs-rest'); }
      });
      function select(t, focus) {
        list.forEach(function (x) {
          var on = x === t;
          x.setAttribute('aria-selected', on ? 'true' : 'false');
          x.tabIndex = on ? 0 : -1;
          var p = document.getElementById(x.getAttribute('aria-controls'));
          if (!p) return;
          if (on) { p.hidden = false; p.classList.remove('is-entering'); void p.offsetWidth; p.classList.add('is-entering'); }
          else p.hidden = true;
        });
        if (focus) t.focus();
        if (t.scrollIntoView && t.parentNode.scrollWidth > t.parentNode.clientWidth) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: reduce ? 'auto' : 'smooth' });
      }
      list.forEach(function (t, k) {
        t.addEventListener('click', function () { select(t, false); });
        t.addEventListener('keydown', function (e) {
          var n = null;
          if (e.key === 'ArrowRight') n = list[(k + 1) % list.length];
          if (e.key === 'ArrowLeft') n = list[(k - 1 + list.length) % list.length];
          if (e.key === 'Home') n = list[0];
          if (e.key === 'End') n = list[list.length - 1];
          if (n) { e.preventDefault(); select(n, true); }
        });
      });
      box.addEventListener('shopify:block:select', function (e) {
        var t = box.querySelector('[aria-controls="arvs-panel-' + e.detail.blockId + '"]');
        if (t) select(t, false);
      });
    });
  }

  function rails() {
    each('[data-arvs-rail-box]', function (box) {
      if (!once(box, 'arvsRail')) return;
      var rail = box.querySelector('[data-arvs-rail]');
      if (!rail) return;
      function stepBy(dir) {
        var card = rail.firstElementChild;
        var w = card ? card.getBoundingClientRect().width + 16 : rail.clientWidth * 0.86;
        rail.scrollBy({ left: dir * w, behavior: reduce ? 'auto' : 'smooth' });
      }
      each('[data-arvs-rail-prev]', function (b) { b.addEventListener('click', function () { stepBy(-1); }); }, box);
      each('[data-arvs-rail-next]', function (b) { b.addEventListener('click', function () { stepBy(1); }); }, box);
    });
  }

  function more() {
    each('[data-arvs-more]', function (btn) {
      if (!once(btn, 'arvsMore')) return;
      btn.addEventListener('click', function () {
        var box = btn.closest('.arvs');
        if (!box) return;
        each('.arvs-rev.is-collapsed', function (r) { r.classList.remove('is-collapsed'); }, box);
        btn.parentNode.hidden = true;
      });
    });
  }

  function init() { reveal(); rings(); galleries(); buyboxes(); sticky(); tabs(); rails(); more(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true }); else init();
  document.addEventListener('shopify:section:load', init);
})();
